<template>
  <div
    class="w-full relative rounded-2xl bg-white overflow-hidden p-4 lg:p-5 group transition-all duration-300 flex border border-gray-100"
    :class="cardType === 'horizontal' ? 'flex-row space-x-4 xl:space-x-6' : 'flex-col'"
  >
    <!-- Image  -->
    <div
      v-if="media"
      class="relative overflow-hidden flex"
      :class="cardType === 'horizontal' ? 'w-2/5 shrink-0 h-full' : 'w-full'"
    >
      <div class="w-full relative" :class="cardType === 'horizontal' ? 'h-full' : ''">
        <div
          class="w-full flex overflow-hidden bg-brand-background rounded-xl"
          :class="cardType === 'horizontal' ? 'h-full' : ''"
        >
          <NuxtLink class="flex w-full relative" :class="cardType === 'horizontal' ? 'h-full' : ''" :to="localePath(link)">
            <AtomsImage
              v-if="media?.mime?.includes('image')"
              class="w-full object-cover object-center rounded-xl hover:scale-110 duration-500"
              :class="[imageClass, cardType === 'horizontal' ? '!h-full' : 'aspect-[4/3]']"
              :media="media"
              :alt="getNewsAlt(media, title)"
              sizeHint="quarter"
            />
            <!-- Pin -->
            <span
              v-if="pin"
              class="text-[10px] uppercase tracking-widest font-bold absolute left-2 top-2 lg:left-4 lg:top-4 bg-white w-fit text-black py-1 px-3 shadow-sm rounded-md z-1"
              v-html="pin"
            ></span>
            <!-- Pin -->
          </NuxtLink>
        </div>
      </div>
    </div>
    <!-- Image  -->

    <!-- Text -->
    <div
      v-if="title || description || button"
      class="flex flex-col overflow-hidden grow"
      :class="cardType === 'vertical' ? 'mt-5 xl:mt-7 w-full' : 'w-3/5 pl-2 lg:pl-0'"
    >
      <!-- Title -->
      <h3
        v-if="title"
        class="w-full font-bold"
        :class="[titleClass, cardType === 'horizontal' ? 'line-clamp-1 xl:line-clamp-2' : '']"
        v-html="title"
      ></h3>
      <!-- Title -->

      <!-- Description -->
      <p
        v-if="description"
        class="w-full leading-relaxed mt-1 xl:mt-2 !text-gray-500"
        :class="[descriptionClass, cardType === 'horizontal' ? 'line-clamp-1' : '']"
        v-html="description"
      ></p>
      <!-- Description -->

      <div
        v-if="cardType === 'horizontal'"
        class="flex justify-end items-center mt-auto pt-4"
      >
        <!-- Button -->
        <AtomsButton
          v-if="link"
          :label="$t('Detail')"
          :link="link"
          :target="target"
          :color="buttonColor"
          fontSize="xs"
          class="!py-1.5 !px-4 xl:!py-2 xl:!px-5"
        />
        <!-- Button -->
      </div>
    </div>
    <!-- Text -->

    <div
      v-if="cardType === 'vertical'"
      class="flex justify-end items-center mt-auto pt-4 px-1"
    >
      <!-- Button -->
      <AtomsButton
        v-if="link"
        :label="$t('Detail')"
        :link="link"
        :target="target"
        color="black"
        size="small"
        class="!py-2 !px-6 font-bold text-sm rounded-lg"
      />
      <!-- Button -->
    </div>
  </div>
</template>
<script setup>
import { useLocalePath } from "#i18n";
import { computed } from 'vue';
import { useSiteSettingsStore } from "@/store/index";
import { getAspectClass } from "~/composables/utils";

const siteSettingsStore = useSiteSettingsStore();
const localePath = useLocalePath();
const props = defineProps({
  pin: { type: String },
  title: {
    type: String,
  },
  description: {
    type: String,
  },
  link: { type: String },
  target: { type: String },
  media: {
    type: Object,
  },
  date: { type: String },
  cardType: { type: String, default: "vertical" },
  mediaSize: { type: String },
  background: { type: String },
});

const isDarkLayout = computed(() => ['first', 'second', 'dark-first', 'dark-second'].includes(props.background));
const imageClass = computed(() => getAspectClass(props.mediaSize));
const getNewsAlt = (media, title) => media?.alternativeText ?? title ?? media?.hash ?? media?.name;
const titleClass = computed(() => [
  isDarkLayout.value ? '!text-white' : 'text-gray-900 font-bold',
  props.cardType === 'vertical' ? 'text-[17px] lg:text-[22px] leading-snug' : 'text-lg',
]);
const descriptionClass = computed(() => [
  isDarkLayout.value ? '!text-white' : 'text-black',
  props.cardType === 'vertical' ? 'text-[13px] lg:text-[15px]' : 'text-sm',
]);
const dateClass = computed(() => (isDarkLayout.value ? '!text-white' : '!text-black'));
const buttonColor = computed(() => (['first', 'second'].includes(props.background) ? 'white' : 'first'));
</script>
